import React from 'react';

import DisplayText from '../text/DisplayText';

export default ({ isDisplay, value, input }) => {
  if(isDisplay) return <DisplayText title={value}/>
  return input;
};